<form [formGroup]="form">
  @if (loading() || loadingContacts()) {
  <app-card [titleKey]="'projectWizard.adminForm.formTitle'">
    <div class="placeholder-glow">
      @for (item of [1,2,3,4,5]; track $index) {
      <div class="mb-3">
        <span class="placeholder col-3 d-block mb-2 rounded"></span>
        <span
          class="placeholder w-100 d-block rounded"
          style="height: 38px"
        ></span>
      </div>
      }
    </div>
  </app-card>
  } @else {
  <app-card [titleKey]="'projectWizard.adminForm.formTitle'">
    <app-validated-dropdown
      [label]="'admin.projectIdeas.details.state'"
      [inputFormControlName]="'state'"
      [inputFormControl]="form.controls.state"
      [disabled]="true"
    >
      <option
        *ngFor="let status of genericProjectStore.projectStatusEntities()"
        [value]="status.id"
      >
        {{ "generic.projectStatus." + status.name | translate }}
      </option>
    </app-validated-dropdown>

    <app-validated-dropdown
      [label]="'admin.projectIdeas.details.projectType'"
      inputFormControlName="projectType"
      [inputFormControl]="form.controls.foundingMode"
      [leaveSpaceForValidation]="true"
    >
      <option
        *ngFor="let type of genericProjectStore.projectFoundingEntities?.() ?? []"
        [value]="type.id"
      >
        {{ "generic.projectFounding." + type.name | translate }}
      </option>
    </app-validated-dropdown>

    <app-validated-dropdown
      [label]="'admin.projectIdeas.details.investmentClassification'"
      inputFormControlName="investmentClassification"
      [inputFormControl]="form.controls.investmentClassification"
      [leaveSpaceForValidation]="true"
    >
      <option
        *ngFor="let classification of genericProjectStore.projectClassificationEntities?.() ?? []"
        [value]="classification.id"
      >
        {{ classification.localized | getLocalized }}
      </option>
    </app-validated-dropdown>

    <app-validated-dropdown
      [label]="'admin.projectIdeas.details.loanTerm'"
      inputFormControlName="loanTerm"
      [inputFormControl]="form.controls.loanTerm"
      [leaveSpaceForValidation]="true"
    >
      <option
        *ngFor="let term of genericProjectStore.projectLoanTermEntities?.() ?? []"
        [value]="term.id"
      >
        {{ "generic.projectLoanTerm." + term.name | translate }}
      </option>
    </app-validated-dropdown>

    <app-card
      [titleKey]="'admin.projectIdeas.details.plannedCollectionPeriod'"
      class="planned-collection-card"
    >
      <div class="row">
        <div class="col-6">
          <app-validated-date-picker
            [label]="'admin.projectIdeas.details.from'"
            [inputFormControlName]="'loanTypePaymentStart'"
            [inputFormControl]="form.controls.loanTypePaymentStart"
            [leaveSpaceForValidation]="true"
          />
        </div>
        <div class="col-6">
          <app-validated-date-picker
            [label]="'admin.projectIdeas.details.to'"
            [inputFormControlName]="'loanTypePaymentEnd'"
            [inputFormControl]="form.controls.loanTypePaymentEnd"
            [leaveSpaceForValidation]="true"
          />
        </div>
      </div>
    </app-card>

    <div class="mt-3">
      <app-card
        [titleKey]="'admin.projectIdeas.details.actualCollectionPeriod'"
        class="planned-collection-card"
      >
        <div class="row">
          <div class="col-6">
            <app-validated-date-picker
              [label]="'admin.projectIdeas.details.from'"
              [inputFormControlName]="'startCollectionDate'"
              [inputFormControl]="form.controls.startCollectionDate"
              [leaveSpaceForValidation]="true"
              [disabled]="!canEditCollectionDates()"
            />
          </div>
          <div class="col-6">
            <app-validated-date-picker
              [label]="'admin.projectIdeas.details.to'"
              [inputFormControlName]="'endCollectionDate'"
              [inputFormControl]="form.controls.endCollectionDate"
              [leaveSpaceForValidation]="true"
              [disabled]="!canEditCollectionDates()"
            />
          </div>
        </div>
      </app-card>
    </div>

    <div class="mt-3">
      <app-validated-dropdown
        [label]="'admin.projectIdeas.details.contactTitle'"
        inputFormControlName="contactId"
        [inputFormControl]="form.controls.contactId"
        [leaveSpaceForValidation]="true"
      >
        <option *ngFor="let contact of contactOptions()" [value]="contact.id">
          {{ contact.label }}
        </option>
      </app-validated-dropdown>
    </div>
  </app-card>
  }
</form>
